import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { GalleryImage } from 'editor/src/store/gallery/types';

import { CustomerLibraryState, LibraryRequest } from './types';

export const customerLibraryInitialState: CustomerLibraryState = {
  enabled: false,
  images: [],
  requests: {},
};

export const slice = createSlice({
  name: 'customerLibrary',
  initialState: customerLibraryInitialState,
  reducers: {
    setLibraryImagesAction: (state, action: PayloadAction<GalleryImage[]>) => {
      state.enabled = true;
      state.images = action.payload;
    },
    setLibraryRequestAction: (state, action: PayloadAction<{ imageId: string; request: LibraryRequest }>) => {
      state.requests[action.payload.imageId] = action.payload.request;
    },
    clearLibraryRequestAction: (state, action: PayloadAction<string>) => {
      delete state.requests[action.payload];
    },
    libraryImageSavedAction: (state, action: PayloadAction<GalleryImage>) => {
      const image = action.payload;
      const index = state.images.findIndex((libraryImage) => libraryImage.id === image.id);
      if (index === -1) {
        state.images.unshift(image);
      } else {
        state.images[index] = image;
      }
      delete state.requests[image.id];
    },
    libraryImageRemovedAction: (state, action: PayloadAction<string>) => {
      state.images = state.images.filter((image) => image.id !== action.payload);
      delete state.requests[action.payload];
    },
  },
});

export const {
  setLibraryImagesAction,
  setLibraryRequestAction,
  clearLibraryRequestAction,
  libraryImageSavedAction,
  libraryImageRemovedAction,
} = slice.actions;

export default slice.reducer;
